/* __next_internal_client_entry_do_not_use__ default auto */import { useEffect } from "react";
import { setupScrollListener } from "@/util/scrollListener";
/**
 * 滚动监听组件
 * 当页面滚动达到一个 innerHeight 高度时，通过 EventBus 发送事件
 * 主要用于详情页（topic/features/blog）控制 ImportModal 的弹出时机
 */
const ScrollListener = () => {
  useEffect(setupScrollListener, []);
  return null;
};
export default ScrollListener;